/* eslint-disable */
import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true,
};

const pre = 'setting-';

export default {
    path: '/setting',
    name: 'setting',
    redirect: {
        name: `${pre}staff`,
    },
    meta,
    component: BasicLayout,
    children: [
        // {
        //   path: 'user',
        //   name: `${pre}user`,
        //   meta: {
        //     ...meta,
        //     title: '个人中心'
        //   },
        //   component: () => import('@/pages/setting/user')
        // },
        {
            path: 'account',
            name: `${pre}account`,
            meta: {
                ...meta,
                title: '系统设置',
            },
            component: () => import('@/pages/setting/account'),
        },
        {
            path: 'role',
            name: `${pre}role`,
            meta: {
                ...meta,
                title: '权限管理',
            },
            component: () => import('@/pages/setting/role'),
        },
        {
            path: 'staff',
            name: `${pre}staff`,
            meta: {
                ...meta,
                title: '员工管理',
            },
            component: () => import('@/pages/setting/staff'),
        },
        {
            path: 'dept',
            name: `${pre}dept`,
            meta: {
                ...meta,
                title: '部门管理',
            },
            component: () => import('@/pages/setting/dept'),
        },
        // {
        //   path: 'customer-tag',
        //   name: `${pre}customer-tag`,
        //   meta: {
        //     ...meta,
        //     title: '客户标签'
        //   },
        //   component: () => import('@/pages/setting/customer-tag')
        // },
        {
            path: 'log',
            name: `${pre}log`,
            meta: {
                ...meta,
                title: '系统日志',
            },
            component: () => import('@/pages/setting/log'),
        },
        {
            path: 'limit',
            name: `${pre}limit`,
            meta: {
                ...meta,
                title: '额度设置',
            },
            component: () => import('@/pages/setting/limit'),
        },
        {
            path: 'notify',
            name: `${pre}notify`,
            meta: {
                ...meta,
                title: '通知设置',
            },
            component: () => import('@/pages/setting/notify'),
        },
        {
            path: 'dict',
            name: `${pre}dict`,
            meta: {
                ...meta,
                title: '字典设置',
            },
            component: () => import('@/pages/setting/dict'),
        },
        {
            path: 'template',
            name: `${pre}template`,
            meta: {
                ...meta,
                title: '模板管理',
            },
            component: () => import('@/pages/setting/template'),
        },
        {
            path: 'rule',
            name: `${pre}rule`,
            meta: {
                ...meta,
                title: '规则设置',
            },
            component: () => import('@/pages/setting/rule'),
        },
    ],
};
